import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PackageX, ArrowLeft } from 'lucide-react';

const NotFound = () => {
    return (
        <div style={{
            height: '100vh',
            width: '100vw',
            backgroundColor: '#f8fafc', // Slate-50
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
            fontFamily: "'Inter', sans-serif",
        }}>
            {/* Background Shape */}
            <div style={{
                position: 'absolute',
                width: '800px',
                height: '800px',
                background: 'radial-gradient(circle, rgba(99,102,241,0.05) 0%, transparent 70%)',
                borderRadius: '50%',
                zIndex: 0,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }} />

            <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                style={{
                    zIndex: 10,
                    textAlign: 'center',
                    maxWidth: '500px',
                    padding: '0 24px',
                }}
            >
                {/* Icon Wrapper with Float Animation */}
                <motion.div
                    animate={{ y: [0, -20, 0] }}
                    transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                    style={{
                        width: '120px',
                        height: '120px',
                        background: '#eef2ff', // Indigo-50
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 32px',
                        color: '#4f46e5', // Indigo-600
                        boxShadow: '0 20px 40px -10px rgba(99, 102, 241, 0.2)',
                        border: '1px solid #e0e7ff',
                    }}
                >
                    <PackageX size={64} strokeWidth={1.5} />
                </motion.div>

                <h1 style={{
                    fontSize: '8rem',
                    fontWeight: 900,
                    lineHeight: 1,
                    margin: 0,
                    color: '#0f172a', // Slate-900
                    letterSpacing: '-0.05em',
                }}>
                    4<span style={{ color: '#6366f1' }}>0</span>4
                </h1>

                <h2 style={{
                    fontSize: '2rem',
                    fontWeight: 700,
                    color: '#1e293b',
                    marginTop: '16px',
                    marginBottom: '16px',
                }}>
                    Lost in Transit?
                </h2>

                <p style={{
                    fontSize: '1.1rem',
                    color: '#64748b',
                    lineHeight: 1.6,
                    marginBottom: '40px',
                }}>
                    The page you are looking for seems to have gone off-grid.
                    It might have been moved, deleted, or never existed.
                </p>

                {/* Home Button with Pulse Animation */}
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <motion.div
                        animate={{
                            boxShadow: [
                                "0 0 0 0 rgba(99, 102, 241, 0.4)",
                                "0 0 0 20px rgba(99, 102, 241, 0)",
                                "0 0 0 0 rgba(99, 102, 241, 0)"
                            ]
                        }}
                        transition={{ duration: 3, repeat: Infinity }}
                        whileHover={{ y: -2, backgroundColor: '#334155' }}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '12px',
                            backgroundColor: '#0f172a',
                            color: 'white',
                            padding: '16px 32px',
                            borderRadius: '50px',
                            fontWeight: 600,
                            fontSize: '1rem',
                            cursor: 'pointer',
                        }}
                    >
                        <ArrowLeft size={20} />
                        Back to Home
                    </motion.div>
                </Link>
            </motion.div>
        </div>
    );
};

export default NotFound;